import { AppRoute } from '@app/core/routing/AppRoute';
import { ReportDefinitionDefaultEditorPage } from '@app/modules/audit/modules/reports/definitions/update/ReportDefinitionDefaultEditorPage';
import { ReportDefinitionEditorPage } from '@app/modules/audit/modules/reports/definitions/update/ReportDefinitionEditorPage';
import {
  ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE,
  adminAuditPaths,
} from '@app/modules/audit/routing/admin-audit-paths';
import { AuditMaterialsPage } from '@app/modules/audit/screens/audit-config/AuditMaterialsPage';
import { AuditTemplatesPage } from '@app/modules/audit/screens/audit-config/AuditTemplatesPage';
import { Redirect, RouteChildrenProps, Switch } from 'react-router-dom';

/**
 * Admin routes for audit templates and materials settings.
 */
export function AdminAuditRoutes(props: RouteChildrenProps) {
  const { path } = props.match!;

  return (
    <Switch>
      <AppRoute path={`${path}/templates/by-id/:id`} component={ReportDefinitionEditorPage} />
      {/* Legacy nested report-definitions URLs */}
      <AppRoute
        path={`${path}/templates/report-definitions/by-id/:id`}
        render={({ match }) => (
          <Redirect to={adminAuditPaths.reportDefinitionById(match.params.id!)} />
        )}
      />
      <AppRoute
        path={`${path}/templates/report-definitions/:reportType/default`}
        render={({ match }) => (
          <Redirect to={adminAuditPaths.reportDefinitionDefault(match.params.reportType!)} />
        )}
      />
      <AppRoute
        path={`${path}/templates/report-definitions/:reportType`}
        render={({ match }) => (
          <Redirect to={adminAuditPaths.reportDefinitions(match.params.reportType!)} />
        )}
      />
      <AppRoute
        path={`${path}/templates/:reportType/default`}
        component={ReportDefinitionDefaultEditorPage}
      />
      <AppRoute path={`${path}/templates/:reportType`} component={AuditTemplatesPage} />
      <Redirect
        exact
        from={`${path}/templates`}
        to={adminAuditPaths.templatesByType(ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE)}
      />
      <AppRoute path={`${path}/materials`} component={AuditMaterialsPage} />
      {/* Legacy flat report-definition URLs under /admin/audit */}
      <AppRoute
        path={`${path}/report-definitions/by-id/:id`}
        render={({ match }) => (
          <Redirect to={adminAuditPaths.reportDefinitionById(match.params.id!)} />
        )}
      />
      <AppRoute
        path={`${path}/report-definitions/:reportType/default`}
        render={({ match }) => (
          <Redirect to={adminAuditPaths.reportDefinitionDefault(match.params.reportType!)} />
        )}
      />
      <AppRoute
        path={`${path}/report-definitions/:reportType`}
        render={({ match }) => (
          <Redirect to={adminAuditPaths.reportDefinitions(match.params.reportType!)} />
        )}
      />
      <Redirect exact from={path} to={adminAuditPaths.root()} />
    </Switch>
  );
}
